import Cookies from 'js-cookie'
import getCookieDomain from '../lib/get-cookie-domain.js'

export const saveTokenCookie = async ({ cookieName, userData }) => {
  if (!cookieName) {
    return
  }

  if (!userData?.access_token) {
    return
  }

  // Store access token in a cookie
  const cookieOptions = {
    expires: 1, // 1 day
    secure: true,
  }
  if (process.env.NODE_ENV === 'development') {
    cookieOptions.secure = false
  }

  const cookieDomain = getCookieDomain()
  if (cookieDomain) {
    cookieOptions.domain = cookieDomain
  }

  Cookies.set(cookieName, userData.access_token, cookieOptions)
}
